import { Controller } from '@hotwired/stimulus'

// Bloque LOPD de la página genérica de subida de documentación (ENH-RNK-025).
// Replica el formato de la vía de tramitación en producción: el dropzone para
// subir la autorización firmada está oculto y aparece al pulsar el enlace
// "¿Ya la tienes firmada? Súbela ahora".
//
// Targets:
//   - hint: el texto/enlace "¿Ya la tienes firmada? Súbela ahora"
//   - dropzone: la zona de subida del PDF firmado (oculta por defecto)
export default class extends Controller {
  static targets = ['hint', 'dropzone']

  mostrarSubida (event) {
    event.preventDefault()
    if (this.hasHintTarget) this.hintTarget.hidden = true
    this.dropzoneTarget.hidden = false
  }
}
